import { createReducer, on } from '@ngrx/store';
import {
  SurveyManagementActions,
  SurveyManagementApiActions,
} from './survey-management.actions';
import {
  INITIAL_SURVEY_MANAGEMENT_STATE,
  SurveyManagementState,
} from './survey-management.model';

export const surveyManagementReducer = createReducer(
  INITIAL_SURVEY_MANAGEMENT_STATE,

  on(
    SurveyManagementActions.assignBuyerProjectManager,
    (state): SurveyManagementState => ({
      ...state,
      buyerProjectManagerUpdating: true,
      error: null,
    }),
  ),
  on(
    SurveyManagementActions.removeBuyerProjectManager,
    (state): SurveyManagementState => ({
      ...state,
      buyerProjectManagerUpdating: true,
      error: null,
    }),
  ),
  on(
    SurveyManagementApiActions.assignBuyerProjectManagerSuccess,
    SurveyManagementApiActions.removeBuyerProjectManagerSuccess,
    (state): SurveyManagementState => ({
      ...state,
      buyerProjectManagerUpdating: false,
      error: null,
    }),
  ),
  on(
    SurveyManagementApiActions.assignBuyerProjectManagerFailure,
    SurveyManagementApiActions.removeBuyerProjectManagerFailure,
    (state, { error }): SurveyManagementState => ({
      ...state,
      buyerProjectManagerUpdating: false,
      error,
    }),
  ),

  on(
    SurveyManagementActions.assignOperatorProjectManager,
    (state): SurveyManagementState => ({
      ...state,
      operatorProjectManagerUpdating: true,
      error: null,
    }),
  ),
  on(
    SurveyManagementActions.removeOperatorProjectManager,
    (state): SurveyManagementState => ({
      ...state,
      operatorProjectManagerUpdating: true,
      error: null,
    }),
  ),
  on(
    SurveyManagementApiActions.assignOperatorProjectManagerSuccess,
    SurveyManagementApiActions.removeOperatorProjectManagerSuccess,
    (state): SurveyManagementState => ({
      ...state,
      operatorProjectManagerUpdating: false,
      error: null,
    }),
  ),
  on(
    SurveyManagementApiActions.assignOperatorProjectManagerFailure,
    SurveyManagementApiActions.removeOperatorProjectManagerFailure,
    (state, { error }): SurveyManagementState => ({
      ...state,
      operatorProjectManagerUpdating: false,
      error,
    }),
  ),
);
